import React from 'react'
import './Header.css'

const Header = () => {
  return (
    <div>Header</div>
  )
}

export default Header